let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fDXOw")).then(() => parcelRequire('k5CKC'));